import React, { useState, useEffect } from "react";
import { C, T, BO } from "../constants/baziData";

// ── Nav ───────────────────────────────────────────────────────────────────────
function Nav({page,setPage,user,onLogout,lang,setLang}){
  const [scrolled,setScrolled]=useState(false);
  useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>30);
    window.addEventListener("scroll",fn);
    return()=>window.removeEventListener("scroll",fn);
  },[]);
  const navItem=(p,label)=>(
    <button onClick={()=>setPage(p)} style={{
      background:page===p?"rgba(6,78,59,.08)":"transparent",
      border:"none",
      color:page===p?C.emerald:C.mist3,
      cursor:"pointer",padding:"6px 10px",borderRadius:6,
      fontSize:14,fontWeight:500,letterSpacing:".04em",
      whiteSpace:"nowrap",
      fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",
      transition:"all .2s",
    }}>{label}</button>
  );
  return(
    <nav style={{
      display:"flex",justifyContent:"space-between",alignItems:"center",
      padding:"0 36px",height:60,
      background:scrolled?"rgba(253,251,247,.97)":"rgba(253,251,247,.88)",
      backdropFilter:"blur(20px) saturate(1.4)",
      WebkitBackdropFilter:"blur(20px) saturate(1.4)",
      borderBottom:`1px solid ${scrolled?"rgba(0,0,0,.10)":"rgba(0,0,0,.05)"}`,
      position:"sticky",top:0,zIndex:200,
      transition:"all .3s ease",
    }}>
      <div onClick={()=>setPage("landing")} style={{cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
        <img src="/logo_transparent.png" alt="澄光能量 LUMINAARC"
             style={{height:36,width:"auto",display:"block"}}
             onError={e=>{ e.target.style.display='none'; }}/>
        <div>
          <div style={{fontSize:17,letterSpacing:".15em",color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",fontWeight:300}}>澄光能量 · LUMINAARC</div>
          <div style={{fontSize:9,letterSpacing:".22em",color:"rgba(212,175,55,.55)",marginTop:1,fontFamily:"'Cormorant Garamond',serif",fontStyle:"italic"}}>澄光能量审计</div>
        </div>
      </div>
      <div style={{display:"flex",gap:2,alignItems:"center"}}>
        {<a href="/profile" style={{background:"transparent",border:"none",cursor:"pointer",color:page==="audit"?C.emerald:C.mist3,padding:"6px 10px",borderRadius:6,fontSize:14,fontWeight:500,letterSpacing:".04em",textDecoration:"none",whiteSpace:"nowrap",fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",transition:"all .2s"}}>{lang==="zh"?"命盘":"Chart"}</a>}
        {navItem("synastry",lang==="zh"?"关系":"Relationships")}
        <a href="/oracle" style={{
          background:C.gold,border:"none",cursor:"pointer",
          color:"#fff",fontSize:14,fontWeight:600,letterSpacing:".04em",
          padding:"7px 16px",borderRadius:8,textDecoration:"none",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",
          transition:"all .2s",whiteSpace:"nowrap",
          boxShadow:"0 2px 8px rgba(212,175,55,.25)",
        }}>🔮 {lang === "en" ? "Ask" : "问卜"}</a>
        {navItem("pricing",lang==="zh"?"计划":"Plans")}
                {user&&<a href="/profile/list" style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:C.gold,fontSize:14,fontWeight:500,letterSpacing:".04em",
          padding:"6px 10px",borderRadius:6,textDecoration:"none",whiteSpace:"nowrap",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",
          transition:"all .2s",
        }}>{lang === "en" ? "Profiles" : "档案"}</a>}
        {user&&<a href="/account" style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:C.gold,fontSize:14,fontWeight:500,letterSpacing:".04em",
          padding:"6px 10px",borderRadius:6,textDecoration:"none",whiteSpace:"nowrap",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",
          transition:"all .2s",
        }}>{lang === "en" ? "Account" : "账户"}</a>}
        {user&&<a href="/dashboard" style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:C.gold,fontSize:14,fontWeight:500,letterSpacing:".04em",
          padding:"6px 10px",borderRadius:6,textDecoration:"none",whiteSpace:"nowrap",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei','Inter','Montserrat',sans-serif",
          transition:"all .2s",
        }}>{lang === "en" ? "Daily" : "日课"}</a>}
        <button onClick={()=>setPage("vajra")} style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:"rgba(184,134,11,0.45)",fontSize:12,letterSpacing:".05em",
          padding:"6px 10px",borderRadius:6,fontFamily:"'Cormorant Garamond',serif",fontStyle:"italic",
          transition:"color .2s",
        }} title={lang==="zh"?"BTF 社群":"BTF Community"} onMouseOver={e=>e.target.style.color="rgba(184,134,11,0.78)"} onMouseOut={e=>e.target.style.color="rgba(184,134,11,0.45)"}>
          ☸
        </button>
        <a href="/vajra/teachings" style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:"#D4AF37",fontSize:12,letterSpacing:".05em",
          padding:"6px 10px",borderRadius:6,textDecoration:"none",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei',sans-serif",
          transition:"all .2s",opacity:0.85,
        }} title={lang==="zh"?"如意宝教法库":"Vajra Dharma Treasury"} onMouseOver={e=>{e.target.style.opacity="1";e.target.style.color="#E8C85A"}} onMouseOut={e=>{e.target.style.opacity="0.85";e.target.style.color="#D4AF37"}}>
          ☸ {lang==="zh"?"教法库":"Teachings"}
        </a>
        <a href="/vajra/subscribe" style={{
          background:"transparent",border:"none",cursor:"pointer",
          color:"rgba(184,134,11,0.45)",fontSize:12,letterSpacing:".05em",
          padding:"6px 10px",borderRadius:6,textDecoration:"none",
          fontFamily:"'Noto Sans SC','PingFang SC','Microsoft YaHei',sans-serif",
          transition:"color .2s",
        }} title={lang==="zh"?"订阅法讯":"Subscribe"} onMouseOver={e=>e.target.style.color="rgba(184,134,11,0.78)"} onMouseOut={e=>e.target.style.color="rgba(184,134,11,0.45)"}>
          法讯
        </a>
        {user&&user.is_admin&&navItem("admin","Admin")}
        <button onClick={()=>setLang(lang==="en"?"zh":"en")} style={{
          background:"rgba(212,175,55,.10)",border:"1px solid rgba(212,175,55,.25)",
          borderRadius:9999,padding:"4px 12px",fontSize:11,color:C.gold,
          cursor:"pointer",letterSpacing:".1em",marginLeft:6,
        }}>{lang==="en"?"中文":"EN"}</button>
        {user
          ?<div style={{display:"flex",gap:8,alignItems:"center",marginLeft:8}}>
            <div style={{fontSize:12,color:C.mist3,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user.email}</div>
            <div style={{background:"rgba(6,78,59,.08)",border:"1px solid rgba(6,78,59,.20)",borderRadius:9999,padding:"2px 10px",fontSize:11,color:C.emerald,letterSpacing:".1em"}}>{user.tier}</div>
            <button style={BO} onClick={onLogout}>{T[lang].signOut}</button>
          </div>
          :<div style={{display:"flex",gap:8,marginLeft:8}}>
            <button style={BO} onClick={()=>setPage("login")}>{T[lang].signIn}</button>
            <button style={{...BO,background:"#064E3B",color:"#fff",border:"none",padding:"8px 18px"}} onClick={()=>setPage("register")}>{T[lang].register}</button>
          </div>
        }
      </div>
    </nav>
  );
}

export default Nav;
